export class TaxSummaryType {
  taxSummaryTypeId!: number;
  name!: string;
}
